export const imageOnError = (e: any, defaultImagePath: string) => {
  if (e.target.src !== window.location.origin + defaultImagePath) {
    e.target.src = defaultImagePath;
  }
};
